import type { FAQ } from "@/lib/faqs";

export default function FAQAccordion({
  faqs,
  group = "faq",
}: {
  faqs: FAQ[];
  group?: string;
}) {
  return (
    <div className="flex flex-col gap-3">
      {faqs.map((faq) => (
        <details
          key={faq.q}
          name={group}
          className="faq-item group rounded-2xl border bg-card px-6 py-5"
        >
          <summary className="flex min-h-[44px] cursor-pointer list-none items-center justify-between gap-4 text-left">
            <span className="font-heading text-[17px] font-semibold text-foreground">
              {faq.q}
            </span>
            <span
              aria-hidden="true"
              className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-base font-bold leading-none text-primary-foreground transition-transform duration-300 group-open:rotate-45"
              style={{ background: "var(--primary)" }}
            >
              +
            </span>
          </summary>
          <p className="pt-3 text-left text-[1.0625rem] leading-relaxed text-muted-foreground">
            {faq.a}
          </p>
        </details>
      ))}
    </div>
  );
}
